import React, { useState, useRef } from 'react';
import './SearchResults.css';
import GoogleLogo from './GoogleLogo';
import KnowledgePanel from './KnowledgePanel';

const BASE_ORGANIC_RESULTS = [
  {
    domain: 'tabelog.com',
    url: 'tabelog.com › tokyo › ebisu',
    title: '恵比寿の和食 ランキングTOP20 - 食べログ',
    snippet: '恵比寿エリアの和食の人気店ランキング。ランチ・ディナーともに個室あり、デート・記念日・接待にも対応したお店を厳選してご紹介。',
  },
  {
    domain: 'gnavi.co.jp',
    url: 'r.gnavi.co.jp › area › ebisu',
    title: '恵比寿 和食ディナー 人気おすすめレストラン - ぐるなび',
    snippet: '恵比寿駅周辺の和食ディナー人気店をご紹介。会席料理・懐石・創作和食など、こだわりの和食を楽しめるレストランを掲載。ネット予約も可能。',
  },
  {
    domain: 'hotpepper.jp',
    url: 'www.hotpepper.jp › area › ebisu',
    title: '恵比寿 和食 おすすめ人気レストラン - ホットペッパーグルメ',
    snippet: '恵比寿の和食レストランをご紹介。お得なクーポン情報・ネット予約もホットペッパーグルメで。現在地から近い順・人気順・口コミ順で絞り込めます。',
  },
  {
    domain: 'retty.me',
    url: 'retty.me › tokyo › ebisu',
    title: '【恵比寿】和食 おすすめランキング - Retty',
    snippet: 'Rettyグルメに投稿されたリアルな口コミをもとにした恵比寿の和食ランキング。実名ユーザーによる信頼性の高い情報で、あなたにぴったりのお店が見つかります。',
  },
  {
    domain: 'google.com',
    url: 'www.google.com › maps › search',
    title: '恵比寿 和食 - Google マップ',
    snippet: '恵比寿近くの和食レストランを地図で確認。営業時間・口コミ・写真・メニューなど詳細情報も掲載。ルート検索もすぐに行えます。',
  },
];

// クエリに基づいて検索結果の文言を調整する関数
function getOrganicResults(query) {
  const normalizedQuery = query.toLowerCase();

  // イタリアンの場合は「和食」を「イタリアン」に置き換え
  if (normalizedQuery.includes('イタリアン')) {
    return BASE_ORGANIC_RESULTS.map(result => ({
      ...result,
      title: result.title.replace(/和食/g, 'イタリアン'),
      snippet: result.snippet.replace(/和食/g, 'イタリアン'),
    }));
  }

  // 和食の場合はそのまま返す
  return BASE_ORGANIC_RESULTS;
}

const TABS = ['AIモード', 'すべて', 'マップ', '画像', '動画', 'ショッピング'];

export default function SearchResults({ query, shouldShowPanel, onBack, onNewSearch }) {
  const [inputVal, setInputVal] = useState(query);
  const [activeTab, setActiveTab] = useState('すべて');
  const inputRef = useRef(null);
  const isSpecial = shouldShowPanel;
  const organicResults = getOrganicResults(query);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') onNewSearch(inputVal);
  };

  return (
    <div className="sr-container">
      {/* ---- Sticky header ---- */}
      <div className="sr-header">
        <div className="sr-header-top">
          <button className="sr-hamburger">
            <svg viewBox="0 0 24 24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
          </button>
          <div className="sr-header-logo-center">
            <GoogleLogo height={30} />
          </div>
          <div className="sr-header-right">
            <svg className="sr-header-icon" viewBox="0 0 24 24"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
            <div className="sr-header-avatar">S</div>
          </div>
        </div>

        <div className="sr-searchbar-row">
          <div className="sr-searchbar" onClick={() => inputRef.current?.focus()}>
            <svg className="sr-search-icon" viewBox="0 0 24 24">
              <path d="M20.49 19l-5.73-5.73C15.53 12.2 16 10.91 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.41 0 2.7-.47 3.77-1.24L19 20.49 20.49 19zM5 9.5C5 7.01 7.01 5 9.5 5S14 7.01 14 9.5 11.99 14 9.5 14 5 11.99 5 9.5z"/>
            </svg>
            <input
              ref={inputRef}
              className="sr-input"
              type="text"
              value={inputVal}
              onChange={(e) => setInputVal(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
            />
            {inputVal && (
              <button className="sr-clear-btn" onClick={() => setInputVal('')}>
                <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
              </button>
            )}
            <button className="sr-mic-btn">
              <svg viewBox="0 0 24 24"><path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V6zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z"/></svg>
            </button>
            <button className="sr-camera-btn">
              <svg viewBox="0 0 24 24"><path d="M12 15.2c-1.77 0-3.2-1.43-3.2-3.2s1.43-3.2 3.2-3.2 3.2 1.43 3.2 3.2-1.43 3.2-3.2 3.2zM9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/></svg>
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="sr-tabs">
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`sr-tab ${activeTab === tab ? 'sr-tab-active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* ---- Results body ---- */}
      <div className="sr-body">
        <div className="sr-stats">約 {isSpecial ? '245,000' : '12,300,000'} 件 (0.{isSpecial ? '42' : '38'} 秒)</div>

        {isSpecial && <KnowledgePanel query={query} />}

        {organicResults.map((r, i) => (
          <div key={i} className="sr-result">
            <div className="sr-result-meta">
              <div className="sr-favicon">
                <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>
              </div>
              <div className="sr-result-source">
                <span className="sr-domain">{r.domain}</span>
                <span className="sr-url">{r.url}</span>
              </div>
              <button className="sr-result-menu">
                <svg viewBox="0 0 24 24"><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
              </button>
            </div>
            <a href="#!" className="sr-result-title">{r.title}</a>
            <p className="sr-result-snippet">{r.snippet}</p>
          </div>
        ))}

        {/* Pagination */}
        <div className="sr-pagination">
          <div className="sr-google-logo-sm">
            <GoogleLogo height={28} />
          </div>
          <div className="sr-page-row">
            <button className="sr-page-btn sr-page-current">1</button>
            <button className="sr-page-btn">2</button>
            <button className="sr-page-btn">3</button>
            <button className="sr-page-btn">4</button>
            <button className="sr-page-next">次へ &rsaquo;</button>
          </div>
        </div>
      </div>
    </div>
  );
}
